import React from 'react'
import Front from '../components/Header/Front'
import Navbar from '../components/Navbar/Navbar'
import Kitchen from '../components/Kitchen/Kitchen'

function FrontPage() {
  return (
    <>
    {/* <Navbar/> */}
    <Front/>
    </>
  )
}

export default FrontPage
